import React from 'react'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import SideBar from '../components/SideBar'
import BusinessAgentEditSection from '../components/BusinessAgentEditSection'

function BusinessAgentEdit() {
  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
            title="Edit Profile"
            subtitle="You can edit you details to upadate your profile"
            breadcrumbs={[
                {label: "Home", path: "/dashboard"},
                {label: "Manage Business Ads Agent", path: "/manage-business-agent"},
                {label: "Business Ads Agent Details"}
            ]}
        />

        <BusinessAgentEditSection/>
    </div>
    </div>
  )
}

export default BusinessAgentEdit